"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MethodInvocation = exports.Invocation = exports.ServiceTaskType = exports.ServiceTask = void 0;
const Constants_1 = require("../Constants");
const ActivityBase_1 = require("./ActivityBase");
/**
 * Describes a BPMN ServiceTask.
 * A ServiceTask is used to call either a function from a specific class,
 * or for performing web requests.
 */
class ServiceTask extends ActivityBase_1.Activity {
    get bpmnType() {
        return Constants_1.BpmnType.serviceTask;
    }
}
exports.ServiceTask = ServiceTask;
/**
 * Describes all currently supported ServiceTask types.
 */
var ServiceTaskType;
(function (ServiceTaskType) {
    ServiceTaskType["external"] = "external";
    ServiceTaskType["internal"] = "internal";
})(ServiceTaskType = exports.ServiceTaskType || (exports.ServiceTaskType = {}));
/**
 * The base class for all invocation types.
 */
class Invocation {
}
exports.Invocation = Invocation;
/**
 * Used by ServiceTasks.
 * This contains the definition for a method invocation.
 */
class MethodInvocation extends Invocation {
}
exports.MethodInvocation = MethodInvocation;
//# sourceMappingURL=ServiceTask.js.map